$(document).ready(function () {

	scrollCue.init();

	// MENU MOBILE
	$('.menu-nav').click(function(e){
	    e.preventDefault();
	    $(this).toggleClass('opened');
	    $('header, nav').toggleClass('opened');
	    $('body').toggleClass('fixed');
		$('.nav-overlay').toggle()
	});
	$('.menu-item a').click(function(){
		$('header, .menu-nav').removeClass('opened');
	});

	// STICKY HEADER
  	$(function () {
    	var sticky = $("header, .menu-nav");
    	$(window).scroll(function () {
      		var scroll = $(window).scrollTop();
      			if (scroll > 80) {
        			sticky.addClass("sticky"); 
      			} else {
					sticky.removeClass("sticky");
      		}
    	});
  	});

	// 100vh FIXED
	document.documentElement.style.setProperty('--vh', '${window.innerHeight/100}px')

	// SCROLL ACHOR
	jQuery(document).ready(function () {
		jQuery('.link_anchor, .link_anchor a').click(function () {
			var target = jQuery(this).attr('href').split('#').pop();
			jQuery('html, body, index').animate({ scrollTop: jQuery('#' + target).offset().top - 60 }, 500);
			return false;
		});
	});
  
	// MODAL
	$('a[name=modal]').click(function(e) {
		e.preventDefault();
		var id = $(this).attr('href');
		$(id).show();
		$('.modal').show();
	 	$('body').css('overflow-y','hidden');
		$('.nav-overlay').show()
		 
	});
	$('.link_close').click(function(){
	 	$('.modal').hide();
		 $('body').css('overflow-y','auto');
	 	$('.nav-overlay').hide()
	})
	var KEYCODE_ESC = 27;
	$(document).keyup(function (e) {
	 	if (e.keyCode == KEYCODE_ESC) {
	 		$('body').css('overflow-y','visible');
	 		$('.modal, .nav-overlay').hide();
	 	}
	});

	// TABS
	if ( $(window).width() > 992 ) {
		$('ul.tabs-1 li').click(function () {
			var tab_id = $(this).attr('data-tab');
			$('ul.tabs-1 li').removeClass('current');
			$('.tab-content').removeClass('current');
			$(this).addClass('current');
			$("#" + tab_id).addClass('current');
		});
	}
	function changeTab (element) {
		var currentTabNav = $(element).closest('.tabs-2');
		var currentContentTab = $('div[data-tab="'+ element.children('a').attr('href') +'"]');
		var previousTab = currentTabNav.find('.tab-link.current');
		var previousContentTab = $('div[data-tab="' + previousTab.children('a').attr('href') + '"]');
		previousTab.removeClass('current');
		previousContentTab.removeClass('current');
		element.addClass('current');
		currentContentTab.addClass('current');
	}
	$('.tab-link a').click(function (e) {
		e.preventDefault()
		var element = $(e.target.parentElement);
		changeTab(element);
	});

	// WRAP WIDTH SLIDE CHART
	$(".grid-chart .a").css({'width':($(".grid-content .a1").width()+'px')});

	// SLICK SLIDER - CHART
    $('.chart-slider').slick({
    	slidesToShow: 1,
    	slidesToScroll: 1,
		arrows: true,
		dots: true
	});

	// ACCORDION
	$('.link_accordion a').click(function() {
		$(this).closest('.box').find('.content').toggle();
		if ($('.tags').hasClass('active')) {
			$('.tags').removeClass('active');
		} else {
			$('.tags').closest('.accordion').find('.active').removeClass('active');
			$('.tags').addClass('active');
		}
		return false;
	});
}); 